import { Controller } from 'stimulus';

// "Who can see this" on the discussion form: everyone on the job, or only
// certain roles (the permit tags). Choosing everyone clears the role picker so
// the save drops the restriction.
export default class extends Controller {
  static targets = ['choice', 'roles', 'select', 'mode'];

  pick(event) {
    event.preventDefault();
    const restricted = event.currentTarget.dataset.visibility === 'roles';

    this.choiceTargets.forEach((choice) => {
      choice.setAttribute('aria-pressed', choice === event.currentTarget ? 'true' : 'false');
    });
    this.rolesTarget.hidden = !restricted;
    this.modeTarget.value = restricted ? 'roles' : 'everyone';

    if (!restricted) {
      const select = this.selectTarget;
      if (select.tomselect) {
        select.tomselect.clear();
      } else {
        Array.from(select.options).forEach((option) => { option.selected = false; });
      }
    }
  }
}
